import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axiosInstance from '../api';

export const getReportOptions = createAsyncThunk<boolean, unknown >('reportOptions', async (groupId) => {
    let response = await axiosInstance.get(`/rest/subscription/reportOptions/dagobah?param=${groupId}`);
    return response.data;
});

export const getDeliveryType = createAsyncThunk<boolean >('deliveryTypes', async () => {
    let response = await axiosInstance.get(`/rest/subscription/deliveryType/dagobah`);
    return response.data;
});

export const getFileType = createAsyncThunk<boolean, number >('fileTypes', async (queryId) =>   {
    let response = await axiosInstance.post(`/rest/subscription/fileType/dagobah`, queryId);
    return response.data;
});


export const getScheduleOptions = createAsyncThunk<boolean, number >('scheduleOptions', async (queryId) => { 
    let response = await axiosInstance.get(`/rest/subscription/scheduleOptions/dagobah?ids=${queryId}`);
    return response.data;
});

export const checkSubscriptionName = createAsyncThunk<any, string >('scheduleOptions', async (subscriptionName) => { 
    let response = await axiosInstance.get(`/rest/subscription/isSubscrNameExists?subscriptionName=${subscriptionName}`);
    return response.data;
});

export const submitSubscribeData = createAsyncThunk<boolean, any >('submit/subscribeData', async (payload) =>   {
    let response = await axiosInstance.post(`/rest/subscription/create`, payload);
    return response.data;
});

export const getSubscriptionData = createAsyncThunk<any >('subscriptionData', async () => {
    let response = await axiosInstance.get(`/rest/accountSubscription/subscriptions`);
    return response.data;
});

export const changeSubscriptionStatus = createAsyncThunk<any, any >('subscription/enable', async (payload) =>   {
    let response = await axiosInstance.post(`/rest/accountSubscription/enable`, payload);
    return response.data;
});

export const unSubscribeSubscription = createAsyncThunk<any, any >('subscription/unsubscribe', async (payload) =>   {
    let response = await axiosInstance.post(`/rest/accountSubscription/delete`, payload);
    return response.data;
});

export const getSubscriptionDetails = createAsyncThunk<any, number >('subscriptionDetails', async (id) => { 
    let response = await axiosInstance.get(`/rest/subscription/subscription?subscrId=${id}`);
    return response.data;
});

export const deliverSubscription = createAsyncThunk<any, any >('subscription/deliver', async (payload) =>   {
    let response = await axiosInstance.post(`/rest/accountSubscription/deliver`, payload);
    return response.data;
});




const initialState: any = {
    reportType: "dagobah",
    queryName:"",
    subscriptionId: null,
    queryId:null,
    groupId:null,
    subscriptionDataLoading: false,
    subscriptionData:[],
    error:null
};

const subscribeSlice = createSlice({
    name: 'subscribe',
    initialState,
    reducers: {
        setCurrentGroupId: (state, action) => {
            state.groupId = action.payload;
        },
        setCurrentQueryId: (state, action) => {
            state.queryId = action.payload;
        },
        setCurrentQueryName: (state, action) => {
            state.queryName = action.payload;
        },
        setSubscriptionId: (state, action) => {
            state.subscriptionId = action.payload;
        },
        updateSubscriptionStatus: (state, 
  action: PayloadAction<{
    id: number | string;
    status: number | string;
  }>) => {
        
            state.subscriptionData = state.subscriptionData.map((item:any)=>{
                if(action.payload.id == item.id) {
                    return {
                        ...item,
                        isEnabled:action.payload.status
                    }
                } 
               return item;
            })
        },
        removeSubscription: (state,action) => {
            state.subscriptionData = state.subscriptionData.filter((item:any) => item.id !== action.payload);
        },
       updateSubscriptionDetail: (
  state,
  action: PayloadAction<{
    id: number | string;
    deliveryMode: number | string;
    subscriptionName: string;
  }>
) => {
  state.subscriptionData = state.subscriptionData.map((item:any) => {
    if (action.payload.id === item.id) {
      return {
        ...item,
        deliveryModeType: action.payload.deliveryMode,
        name: action.payload.subscriptionName,
      };
    }
    return item;
  });
},

        

    },
    extraReducers: (builder) => {
        builder
            .addCase(getSubscriptionData.pending, (state) => {
                state.subscriptionDataLoading = true;
            })
            .addCase(getSubscriptionData.fulfilled, (state, action) => {
                state.subscriptionDataLoading = false;
                if(action.payload?.length > 0) {
                   state.subscriptionData = action.payload;
                }
                // if(action.payload !== -1) {
                //     state.groupId = action.payload;
                // }
            })
            .addCase(getSubscriptionData.rejected, (state, action) => {
                state.subscriptionDataLoading = false;
                state.error = action.error.message || null;
            })
    },
});

export const { setCurrentQueryId, setCurrentGroupId, setCurrentQueryName, setSubscriptionId,updateSubscriptionStatus,removeSubscription,updateSubscriptionDetail } = subscribeSlice.actions;
export default subscribeSlice.reducer;

export const getSettledValue = <T>(result: PromiseSettledResult<T>) => {
  return result.status === "fulfilled" ? result.value : null;
};

export const getSettledError = <T>(result: PromiseSettledResult<T>) => {
  return result.status === "rejected" ? result.reason : null;
};

